import Contact from './contact'
import ContactPageQuery from './contact.query'

export { ContactPageQuery }

export default Contact
